// src/Notifications.js

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import fetchWithAuth from "./fetchWithAuth";
import { FaHome, FaTrash } from "react-icons/fa";
import "./style-new.css";
import { MdCancel } from "react-icons/md";


const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteMode, setDeleteMode] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await fetchWithAuth("/api/notifications");
        if (!response) return;

        const data = await response.json();
        if (data.success) {
          setNotifications(data.notifications);
        } else {
          console.error("Failed to load notifications");
        }
      } catch (err) {
        console.error("Error fetching notifications:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, [token]);

  const markAsRead = async (id) => {
    try {
      const response = await fetch(`/api/notifications/${id}/mark-read`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.success) {
        setNotifications((prev) =>
          prev.map((n) => (n.id === id ? { ...n, is_read: true } : n))
        );
      } else {
        console.error("Failed to mark as read");
      }
    } catch (err) {
      console.error("Error updating notification:", err);
    }
  };

  const toggleDeleteMode = () => {
    setDeleteMode((prev) => !prev);
    setSelectedIds([]);
  };

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const deleteSelected = async () => {
    try {
      const response = await fetch("/api/notifications/delete-multiple", {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ids: selectedIds }),
      });

      const data = await response.json();
      if (data.success) {
        setNotifications((prev) =>
          prev.filter((n) => !selectedIds.includes(n.id))
        );
        setSelectedIds([]);
        setDeleteMode(false);
      } else {
        console.error("Failed to delete notifications");
      }
    } catch (err) {
      console.error("Error deleting notifications:", err);
    }
  };

  const deleteAll = async () => {
    try {
      const response = await fetch("/api/notifications/delete-all", {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (data.success) {
        setNotifications([]);
        setSelectedIds([]);
        setDeleteMode(false);
      } else {
        console.error("Failed to delete all notifications");
      }
    } catch (err) {
      console.error("Error deleting all notifications:", err);
    }
  };

  return (
    <div className="page-container">
      <h2 className="section-heading">Notifications</h2>

      <div className="button-group" style={{ marginBottom: "15px" }}>
        <button
          className="btn btn-primary"
          onClick={() => navigate("/")}
        >
          <FaHome /> Home
        </button>

{/* DELETE mode toggle (only show when NOT in delete mode) */}
{!deleteMode && (
  <button
    className="btn small-btn pastel-red"
    onClick={toggleDeleteMode}
  >
    <FaTrash style={{ marginRight: '5px' }} />
    Delete
  </button>
)}

{/* DELETE MODE UI */}
{deleteMode && (
  <>
    {/* CANCEL button with MdCancel icon */}
    <button
      className="btn small-btn pastel-red"
      onClick={toggleDeleteMode}
    >
      <MdCancel style={{ marginRight: '5px' }} />
      Cancel
    </button>

    {/* DELETE ALL button */}
    <button
      className="btn small-btn pastel-red"
      onClick={deleteAll}
    >
      <FaTrash style={{ marginRight: '5px' }} />
      Delete All
    </button>

    {/* DELETE SELECTED button (only if items are selected) */}
    {selectedIds.length > 0 && (
      <button
        className="btn pastel-red"
        onClick={deleteSelected}
      >
        <FaTrash style={{ marginRight: '5px' }} />
        Delete Selected
      </button>
    )}
  </>
)}
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : notifications.length === 0 ? (
        <p>No notifications yet.</p>
      ) : (
        <ul className="notification-list">
          {notifications.map((notification) => (
            <li
              key={notification.id}
              className={`notification-item ${
                notification.is_read ? "read" : "unread"
              }`}
              onClick={() =>
                !notification.is_read && !deleteMode
                  ? markAsRead(notification.id)
                  : null
              }
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px",
                borderBottom: "1px solid #ccc",
                cursor: deleteMode ? "default" : "pointer",
              }}
            >
              {deleteMode && (
                <input
                  type="checkbox"
                  checked={selectedIds.includes(notification.id)}
                  onChange={() => toggleSelect(notification.id)}
                  style={{ marginRight: "10px" }}
                />
              )}
              <div>
                <p className="notification-message">{notification.message}</p>
                <span className="notification-time">
                  {new Date(notification.created_at).toLocaleString()}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Notifications;
